import LinksList from './links-list';
import Social from './social';
import {
  CURRENT_YEAR,
  FOOTER_GUIDES_LINKS,
  FOOTER_TOOLS_LINKS,
  HUB_FOOTER_LINKS,
  MORE_FOOTER_LINKS
} from '@lib/constants';

const Footer = () => {
  return (
    <footer className="bg-neutral-800" aria-labelledby="footerHeading">
      <h2 id="footerHeading" className="sr-only" data-cy="footer-heading">
        {'Footer'}
      </h2>
      <div
        id="hub-footer"
        className="px-4 py-12 mx-auto max-w-7xl md:px-16 lg:py-16"
      >
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <LinksList title="Tools" links={FOOTER_TOOLS_LINKS} />
              <LinksList
                title="Games"
                links={FOOTER_GUIDES_LINKS}
                classes="mt-12 md:mt-0"
              />
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <LinksList title="More" links={MORE_FOOTER_LINKS} />
              <LinksList
                title="Hub"
                links={HUB_FOOTER_LINKS}
                classes="mt-12 md:mt-0"
              />
            </div>
          </div>
        </div>
        <div className="pt-8 mt-8 border-t border-neutral-600 md:flex md:items-center md:justify-between">
          <div
            className="flex text-neutral-50 space-x-2 md:order-2"
            data-cy="social-links"
          >
            <Social />
          </div>
          <p className="mt-8 text-xs text-neutral-50 md:mt-0 md:order-1">
            &copy;{` ${CURRENT_YEAR} FFHub. All rights reserved.`}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
